module.exports = __webpack_public_path__ + "img/目标1.462eec5f.png";